<template>
  <!-- ColumnChart starts here   -->
  <div class="row">
    <div class="col-xs-12 chart-wrapper zonal-wrapper">
      <div class="chart-title zonal-chart">
        <!-- <div class="row"> -->
        <label class="hidden">{{ multiselectPlaceholderComputed }}</label>
        <div class="text-center web-features columnchart-label">
          <div class="col-xs-12 col-md-3 text-xs-center title_placement">
            <h4 class="white--text">
              <!-- Comparison of Multiple Data sets across states -->
              MULTI-DATASET COMPARISON SECTION
            </h4>
          </div>
          <div class="col-xs-12 col-md-5 multi-select_x1">
            <multi-select
              v-model="selectedIndicator"
              :options="optionIndicators"
              group-values="indicators"
              style="transform: scale(0.9); font-weight: normal"
              group-label="programArea"
              :group-select="false"
              @search-change="multiselectSearch()"
              :group-collapsible="collapsible"
              @close="closedMultiselect(selectedIndicator.name)"
              :group-collapsible-expanded="false"
              @open="openedMultiselect"
              :show-labels="false"
              :placeholder="multiselectPlaceholder"
              :allow-empty="false"
              track-by="name"
              label="name"
              ><span slot="noResult"
                >Oops! No elements found. Change the search query.</span
              >
            </multi-select>
          </div>
          <div class="col-xs-12 col-md-4">
            <multi-select
              v-model="selectedSource"
              :options="optionsSource"
              group-values="years"
              group-label="sources"
              style="transform: scale(0.9); font-weight: normal"
              :multiple="true"
              :group-collapsible="true"
              :placeholder="sourceMultiselectPlaceholder"
              @open="openedSourceMultiselect"
              :showInput="false"
              :group-collapsible-expanded="false"
              :max="4"
              :allow-empty="false"
              @close="closedSourceMultiselect(selectedSource.name)"
              :show-labels="false"
              track-by="name"
              label="name"
              class="autoMaxHeight"
            >
              <span slot="maxElements">Maximum of four selections</span>
            </multi-select>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="chart-stage column-chart-container">
        <highcharts :options="optionsObj"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "@/assets/js-on/vue-multiselect";
import vueSlider from "vue-slider-component";
import { Carousel3d, Slide } from "vue-carousel-3d";
import sortObjects from "@/assets/js-on/sortObjects";
import { log, series } from "async";
import { eventBus } from "../../../../main.js";

export default {
  name: "columnCharts",
  components: { Carousel3d, Slide, MultiSelect, vueSlider },

  props: [
    "optionsIndicator",
    "meta_data",
    "appData",
    "dashboardStateOptions",
    "contextSelectedIndicator",
    "optionSourcess",
  ],
  data() {
    return {
      // fullscreen: true,
      click: 1,
      selectedYear: "",
      optionYear: [],
      dataSource: [],
      columns: [],
      optionsSource: [],
      optionSources: [
        "MICS",
        "NDHS",
        "NARHS",
        "NMIS",
        "NNHS",
        "NHMIS",
        "World Bank",
        "IHME",
        "WHO-GHO",
        "WUENIC",
        "PCCS",
        "UNAIDS",
        "NHSPSS",
        "NHA",
        "KDGHS",
        "NAIIS",
      ],

      optionIndicators: [],
      tableColumnHeaderAttr: [],
      collapsible: true,
      selectedSource: { name: "MICS:2021" },
      selectedIndicator: { name: "MICS:2021" },
      optionStates: [
        "National",
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Benue",
        "Borno",
        "Bayelsa",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kebbi",
        "Kano",
        "Katsina",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara",
      ],
      optionsYear: [2013, 2014, 2015, 2016, 2017],
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      metaData: JSON.parse(this.$ls.get("meta_data_dataset")),

      nationalTarget: "",
      sdgTarget: "",
      optionsObj: {
        chart: {
          type: "column",
          zoomType: "xy",
          height: 400,
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 850,
                },
                xAxis: {
                  type: "category",

                  labels: {
                    rotation: 0,
                    style: {
                      fontSize: "9px",
                      fontFamily: '"Open Sans", sans-serif',
                      fontWeight: "600",
                    },
                  },
                },
              },
            },
          ],
        },
        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
          },
        },
        subtitle: {
          text: "",
        },
        colors: [
          "#17606B",
          "#E85D58",
          "#58B74E",
          "#58A5E8",
          "#CF3C64",
          "#BB7A17",
        ],
        xAxis: {
          type: "category",

          labels: {
            rotation: -45,
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
            },
          },
        },
        credits: {
          enabled: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Values",
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
            },
          },
          gridLineWidth: 0,
          labels: {
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
            },
          },
        },
        plotOptions: {
          series: {
            grouping: true,
            shadow: false,
            pointWidth: 8,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "{point.y:.1f}",
              style: {
                fontSize: "8px",
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: "normal",
                color: "#333333",
              },
            },
          },
        },

        tooltip: {
          pointFormat: "{series.name}: <b>{point.y:.1f} </b>",
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "printChart",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",

                "openInCloud",
              ],

              symbol: "download",
            },
          },
        },
      },

      dataSources: [
        "MICS",
        "NDHS",
        "NARHS",
        "NMIS",
        "NNHS",
        "NHMIS",
        "World Bank",
        "IHME",
        "WHO-GHO",
        "WUENIC",
        "PCCS",
        "UNAIDS",
        "NHSPSS",
        "NHA",
        "KDGHS",
        "NAIIS",
      ],
      // dataSourceDescription: {
      //   mics: "MICS", nhmis: 'NHMIS', nnhs: 'NNHS', ndhs: 'NDHS', nmis: 'NMIS', narhs: 'NARHS',
      //   world_bank: 'World Bank', ihme: 'IHME', ihme_sdg: 'IHME-SDG', who: 'WHO-GHO', wuenic: 'WUENIC', pccs: 'PCCS', unaids: 'UNAIDS', nhspss: 'NHSPSS', nha: 'NHA', kdghs: 'KDGHS', naiis: 'NAIIS'
      // }, // , ibbs:'IBBS'
      tempData: "",
      multiselectPlaceholder: "",
      sourceMultiselectPlaceholder: "",
    };
  },
  methods: {
    openedMultiselect() {
      this.multiselectPlaceholder = "Search indicators";
    },
    closedMultiselect(e) {
      this.multiselectPlaceholder = e;
    },
    openedSourceMultiselect() {
      this.sourceMultiselectPlaceholder = "Search data source";
    },
    closedSourceMultiselect(e) {
      this.sourceMultiselectPlaceholder = "";
      // console.log(e)
    },
    multiselectSearch() {
      this.collapsible = false;
    },
    getDisplayFactor() {
      let displayFactor = "";
      for (const i in this.metaData) {
        if (this.metaData[i][0] === this.selectedIndicator.name) {
          displayFactor = this.metaData[i][3];
          break;
        }
      }
      this.optionsObj.yAxis.title.text = displayFactor;
    },
    removeArrayElementByValue(arr) {
      var what,
        a = arguments,
        L = a.length,
        ax;
      while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1);
        }
      }
      return arr;
    },
    getCurrentSourceOptions() {
      let sourceYear = {};
      var statesByIndicatorByYear = this.$store.getters
        .getCurrentIndicatorsValue;
      this.optionStates.map((element, index) => {
        var selectedStateByIndicatorByYear = statesByIndicatorByYear[element];
        this.dataSources.map((elem, index) => {
          let indicatorSource = this.selectedIndicator.name + " -> " + elem;
          if (!sourceYear[elem])
            sourceYear[elem] = this.getYearOptions(
              selectedStateByIndicatorByYear,
              indicatorSource
            );
        });
      });
      let tempOptions = {};
      let multiselectOptions = [];
      Object.keys(sourceYear).map((elem, index) => {
        if (sourceYear[elem].length > 0) {
          tempOptions.sources = elem;
          tempOptions.years = [];

          sourceYear[elem].forEach((el, i) => {
            tempOptions.years.push({ name: elem + ":" + el });
          });
          multiselectOptions.push(tempOptions);
        }
        tempOptions = {};
      });

      this.optionsSource = multiselectOptions;
    },
    plotZonalChart() {
      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[
        this.selectedIndicator.name
      ];
      var vt = ivt[1] === "P" ? "%" : "";
      var it = ivt[1] === "P" ? "% of total" : "";
      this.optionsObj.tooltip.pointFormat =
        '<span style="color:black; font-family: "Open Sans", sans-serif; font-weight: bold;"><b>{point.y:.2f}' +
        it +
        "</b> </span><br/>";
      this.optionsObj.plotOptions.series.dataLabels.format =
        "{point.y:.1f}" + vt;
      this.optionsObj.plotOptions.series.pointWidth = 8;
      this.optionsObj.title.text = this.selectedIndicator.name;
      this.getCurrentSourceOptions();
      this.optionsObj.series = [];
      this.optionsObj.exporting.filename =
        this.selectedIndicator.name + " " + this.selectedSource.name;
      if (Array.isArray(this.selectedSource)) {
        var series_value = this.getChartData(this.selectedSource[0].name);
        series_value.forEach((el, i) => {
          if (el === "") {
            el = 0;
          }
        });
        var series_data = {
          name: this.selectedSource[0].name,
          data: this.getChartData(this.selectedSource[0].name),
        };
        this.optionsObj.series.push(series_data);
      } else {
        var series_value = this.getChartData(this.selectedSource.name);
        series_value.forEach((el, i) => {
          if (el === "") {
            el = 0;
          }
        });
        var series_data = {
          name: this.selectedSource.name,
          data: this.getChartData(this.selectedSource.name),
        };

        this.optionsObj.series.push(series_data);
      }
      let nationalTarget;
      let sdgTarget;

      this.meta_data.map((elem) => {
        if (this.selectedIndicator.name == elem[0]) {
          nationalTarget = elem[7];
          sdgTarget = elem[10];

          this.nationalTarget = nationalTarget;
          this.sdgTarget = sdgTarget;
        }
      });

      this.optionsObj.yAxis.plotLines = [];
      let nationalTargetLine = {
        id: "nationalLineID",
        color: "#222222",
        width: 0.5,
        value: this.nationalTarget,
        label: {
          text: "NT: " + this.nationalTarget + vt, // vt is value type; whether percentage or number
          align: "right",
          rotation: 0,
          y: -10,
          x: 0,
        },
      };

      let sdgTargetLine = {
        id: "sdgLineID",
        color: "#222222",
        width: 0.5,
        value: this.sdgTarget,
        dashStyle: "longdashdot",
        label: {
          text: "SDG: " + this.sdgTarget + vt, // vt is value type; whether percentage or number
          align: "right",
          rotation: 0,
          y: 15,
          x: 0,
        },
      };
      if (this.nationalTarget) {
        this.optionsObj.yAxis.plotLines.push(nationalTargetLine);
      }

      if (this.sdgTarget) {
        this.optionsObj.yAxis.plotLines.push(sdgTargetLine);
      }
    },
    onSourceChangedMethod() {
      //Set highchart options for cases when this method is called first
      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[
        this.selectedIndicator.name
      ];
      var vt = ivt[1] === "P" ? "%" : "";
      var it = ivt[1] === "P" ? "% of total" : "";
      this.optionsObj.tooltip.pointFormat =
        '<span style="color:black; font-weight: bold;"><b>{point.y:.2f}' +
        it +
        "</b> </span><br/>";
      this.optionsObj.plotOptions.series.dataLabels.format =
        "{point.y:.1f}" + vt;
      this.optionsObj.series = [];
      this.optionsObj.plotOptions.series.pointWidth =
        8 - this.selectedSource.length;
      this.optionsObj.title.text = this.selectedIndicator.name;

      for (var j in this.selectedSource) {
        var series_value = this.getChartData(this.selectedSource[j].name);

        series_value.forEach((el, i) => {
          if (el === "") {
            el = 0;
          }
        });
        // console.log(series_value);

        var series_data = {
          name: this.selectedSource[j].name,
          data: series_value,
        };

        // console.log(series_data);

        this.optionsObj.series.push(series_data);
        // console.log(this.optionsObj.series);
      }
    },
    getYearOptions(data, selectedIndicator) {
      let yearArray = [];
      let indexOfindicatorSource =
        this.lsData[0].indexOf(selectedIndicator) - 1;
      data.map((elem, index) => {
        if (
          elem[indexOfindicatorSource] !== "" &&
          indexOfindicatorSource > -1
        ) {
          yearArray.push(elem[0]);
        }
      });

      return yearArray.sort(function (a, b) {
        return b - a;
      });
    },
    getChartData(selectedSource) {
      // var dataArray = []; //previous implementation
      var dataArray2 = [];
      let statesByIndicatorByYear = this.$store.getters
        .getCurrentIndicatorsValue;
      let selectedSourceAndYear = selectedSource.split(":");
      let indicatorSource =
        this.selectedIndicator.name + " -> " + selectedSourceAndYear[0];
      let indexOfIndicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
      this.optionStates.map((element, index) => {
        let stateData = statesByIndicatorByYear[element];

        stateData.map((elem, index) => {
          if (
            indexOfIndicatorSource > -1 &&
            elem[0] === parseFloat(selectedSourceAndYear[1])
          ) {
            dataArray2.push([element, elem[indexOfIndicatorSource]]);
            // console.log(element +" - "+ elem[indexOfIndicatorSource]);
          }
        });
      });
      let stateOptions = [];
      // this.getCurrentSourceOptions();

      if (
        !(Array.isArray(this.selectedSource) && this.selectedSource.length > 1)
      ) {
        let tempArray = dataArray2.slice(1);
        tempArray.sort((a, b) => {
          return b[1] - a[1];
        });

        tempArray.unshift(dataArray2[0]);
        dataArray2 = tempArray;

        stateOptions = dataArray2.map((el, ind) => {
          return el[0];
        });

        this.optionStates = stateOptions;
      }

      return dataArray2;
    },
  },
  computed: {
    multiselectPlaceholderComputed() {
      this.multiselectPlaceholder = this.selectedIndicator.name;
      this.sourceMultiselectPlaceholder = "";
    },
  },
  created() {
    // get the program area indicator grouping
    this.dataSources = this.optionSources;
  },
  mounted() {
    if (this.dashboardStateOptions.length > 0) {
      if (this.dashboardStateOptions[4].indexOf("_") > 0) {
        this.selectedIndicator.name = this.dashboardStateOptions[4].replace(
          "_",
          "/"
        );
      } else {
        this.selectedIndicator.name = this.dashboardStateOptions[4];
      }
      if (this.dashboardStateOptions[3].indexOf(",") > 0) {
        let selectedSource = this.dashboardStateOptions[1].split(",");
        // console.log(selectedSource);
        this.selectedSource = [];
        for (var i in selectedSource) {
          let tempSourceObj = {
            name: selectedSource[i],
          };
          this.selectedSource.push(tempSourceObj);
        }
      } else {
        this.selectedSource.name = this.dashboardStateOptions[3];
      }
    } else {
      this.selectedIndicator.name = "Skilled attendance at delivery or birth";
    }
    this.$emit("columnChartIndicator", this.selectedIndicator.name);
    if (this.appData) {
      this.optionIndicators = this.optionsIndicator;
      this.getCurrentSourceOptions();
      if (this.dashboardStateOptions[3]) {
        if (this.dashboardStateOptions[3].indexOf(",") > 0) {
          let selectedSource = this.dashboardStateOptions[1].split(",");
          this.selectedSource = [];
          for (var i in selectedSource) {
            let tempSourceObj = {
              name: selectedSource[i],
            };
            this.selectedSource.push(tempSourceObj);
          }
        } else {
          this.selectedSource.name = this.dashboardStateOptions[3];
        }
      } else {
        //console.log(this.optionsSource[0])
        var years = [];
        for (var i in this.optionsSource[1].years) {
          let tempYear = this.optionsSource[1].years[i].name.split(":");
          years.push(tempYear[1]);
        }

        let currentYear = Math.max.apply(null, years);
        this.selectedSource = {
          name: `${this.optionsSource[3].sources}:${currentYear}`,
        };
      }
      if (Array.isArray(this.selectedSource) && this.selectedSource.length > 1)
        this.onSourceChangedMethod();
      else {
        this.plotZonalChart();
      }
    }
    this.$emit("callerName", "columnChartIndicator");
    this.$emit("columnChartIndicator", this.selectedIndicator.name);
  },
  updated() {},
  watch: {
    //feeds ndOptions to numerator-denominator
    optionsSource(val) {
      //  console.log(val);
      eventBus.$emit("ndOptionsEvent", val);
    },
    selectedSource(name) {
      if (this.lsData) {
        this.$emit("callerName", "columnChartSource");
        this.$emit("columnChartSource", name);
        if (Array.isArray(name) && name.length > 1)
          this.onSourceChangedMethod();
        else {
          this.plotZonalChart();
        }
      }
    },
    appData(val) {
      if (val) {
        this.lsData = val;
        this.optionIndicators = this.optionsIndicator;
        this.getCurrentSourceOptions();
        if (this.dashboardStateOptions[3]) {
          if (this.dashboardStateOptions[3].indexOf(",") > 0) {
            let selectedSource = this.dashboardStateOptions[3].split(",");
            this.selectedSource = [];
            for (var i in selectedSource) {
              let tempSourceObj = {
                name: selectedSource[i],
              };
              this.selectedSource.push(tempSourceObj);
            }
          }
        } else {
          var years = [];
          for (var i in this.optionsSource[3].years) {
            let tempYear = this.optionsSource[3].years[i].name.split(":");
            years.push(tempYear[1]);
          }
          let currentYear = Math.max.apply(null, years);
          this.selectedSource = {
            name: `${this.optionsSource[3].sources}:${currentYear}`,
          };
        }
        if (
          Array.isArray(this.selectedSource) &&
          this.selectedSource.length > 1
        )
          this.onSourceChangedMethod();
        else {
          this.plotZonalChart();
        }
        if (this.metaData) {
          this.getDisplayFactor();
        }
      }
    },

    "selectedIndicator.name"(val) {
      this.selectedYear = Math.max.apply(null, this.yearOptions);
      this.getCurrentSourceOptions();
      if (this.dashboardStateOptions[3]) {
        if (this.dashboardStateOptions[3].indexOf(",") > 0) {
          let selectedSource = this.dashboardStateOptions[3].split(",");
          this.selectedSource = [];
          for (var i in selectedSource) {
            let tempSourceObj = {
              name: selectedSource[i],
            };
            this.selectedSource.push(tempSourceObj);
            // console.log(tempSourceObj);
          }
        }
      } else {
        var years = [];
        var theSource = [];
        var mics_index = 0;
        for (var i = 0; i < this.optionsSource.length; i++) {
          theSource.push(this.optionsSource[i].sources);
          mics_index = theSource.indexOf("MICS");
        }
        if (mics_index !== -1) {
          for (var i in this.optionsSource[mics_index].years) {
            let tempYear = this.optionsSource[mics_index].years[i].name.split(
              ":"
            );
            years.push(tempYear[1]);
          }
        } else {
          for (var i in this.optionsSource[0].years) {
            let tempYear = this.optionsSource[0].years[i].name.split(":");
            years.push(tempYear[1]);
          }
        }

        let currentYear = Math.max.apply(null, years);
        if (mics_index !== -1) {
          this.selectedSource = { name: `MICS:${currentYear}` };
        } else {
          this.selectedSource = {
            name: `${this.optionsSource[0].years[0].name}`,
          };
        }

        // console.log(this.selectedSource);
      }
      this.plotZonalChart();
      this.$emit("callerName", "columnChartIndicator");
      this.$emit("columnChartIndicator", val);
      if (this.metaData) {
        this.getDisplayFactor();
      }
    },
    optionsIndicator(val) {
      this.optionIndicators = val;
    },
    meta_data(val) {
      if (val) {
        this.metaData = val;
        this.getDisplayFactor();
      }
    },
    dashboardStateOptions(val) {
      if (val) {
        if (val[4].indexOf("_") > 0) {
          this.selectedIndicator.name = val[4].replace("_", "/");
        } else {
          this.selectedIndicator.name = val[4];
        }
        if (val[3].indexOf(",") > 0) {
          let selectedSource = val[3].split(",");
          this.selectedSource = [];
          for (var i in selectedSource) {
            let tempSourceObj = {
              name: selectedSource[i],
            };
            this.selectedSource.push(tempSourceObj);
          }
        } else {
          this.selectedSource.name = val[3];
        }
      } else {
        this.selectedIndicator.name = "Skilled attendance at delivery or birth";
      }
      this.$emit("columnChartIndicator", this.selectedIndicator.name);
    },
    contextSelectedIndicator(val) {
      this.selectedIndicator = val;
    },
  },
};
</script>

<style scoped>
div[class^="col"] {
  padding-left: 7px;
  padding-right: 7px;
}

.rowlTop {
  margin-bottom: -30px !important;
}

.rowlBot {
  margin-top: -30px !important;
}

/* Some styles live in App.vue file*/
</style>



// WEBPACK FOOTER //
// columnChart.vue?6f9ccd43